import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { TableRow, TableCell, Typography, Grid } from '@mui/material';
import { Warning } from '@mui/icons-material';
export function EmptyRow(props) {
    const { title, colSpan } = props;
    return (_jsx(TableRow, { children: _jsx(TableCell, { colSpan: colSpan != null ? colSpan : 2, children: _jsxs(Grid, { container: true, justifyContent: "center", alignItems: "center", spacing: 1, children: [_jsx(Grid, { item: true, children: _jsx(Warning, {}) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "body2", children: title != null ? title : 'Нет ни одного элемента' }) })] }) }) }));
}
